export default "__VITE_ASSET__DWVK4Hb4__"